import moment from 'moment'
import React, { createContext, ReactNode, useContext, useState } from 'react'
import { useRecoilState } from 'recoil'

import { SchedulePeriod } from '@/shared/services/api/schedule/get-schedule-for-period'
import { userState } from '@/shared/state/user/user'

const ScheduleContext = createContext<{
  contentSchedule: SchedulePeriod[]
  setContentSchedule: (contentSchedule: SchedulePeriod[]) => void
  viewScheduleStatus: boolean
  setViewSheduleStatus: (viewScheduleStatus: boolean) => void
  currentDate: string
  setCurrentDate: (currentDate: string) => void
  startDate: string
  setStartDate: (startDate: string) => void
  endDate: string
  setEndDate: (endDate: string) => void
  onChangePeriod: (date: string) => void
  handleChangePeriod: (startDate: string, endDate: string) => void
  viewShedule: (status: boolean) => void
  userId: string
  setUserId: (userId: string) => void
  isOpenInModal: boolean
  setIsOpenInModal: (isOpenInModal: boolean) => void
  therapistDescription: {
    name: string
    avatar: string
  }
  setTherapistDescription: (therapistDescription: {
    name: string
    avatar: string
  }) => void
}>({
  contentSchedule: [],
  setContentSchedule: () => {},
  viewScheduleStatus: true,
  setViewSheduleStatus: () => {},
  currentDate: moment().format('YYYY-MM-DD'),
  setCurrentDate: () => {},
  startDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
  setStartDate: () => {},
  endDate: moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss'),
  setEndDate: () => {},
  onChangePeriod: () => {},
  handleChangePeriod: () => {},
  viewShedule: () => {},
  userId: '',
  setUserId: () => {},
  isOpenInModal: false,
  setIsOpenInModal: () => {},
  therapistDescription: {
    name: '',
    avatar: ''
  },
  setTherapistDescription: () => {}
})

export const ScheduleProvider = ({ children }: { children: ReactNode }) => {
  const [contentSchedule, setContentSchedule] = useState<SchedulePeriod[]>([])
  const [viewScheduleStatus, setViewSheduleStatus] = useState<boolean>(true)
  const [userRecoilState] = useRecoilState(userState)
  const [therapistDescription, setTherapistDescription] = useState<{
    name: string
    avatar: string
  }>({
    name: '',
    avatar: ''
  })
  const [currentDate, setCurrentDate] = useState<string>(
    moment().format('YYYY-MM-DD')
  )
  const [startDate, setStartDate] = useState<string>(
    moment().format('YYYY-MM-DDTHH:mm:ss')
  )
  const [endDate, setEndDate] = useState<string>(
    moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss')
  )

  const [userId, setUserId] = useState<string>(userRecoilState.personaId)

  const [isOpenInModal, setIsOpenInModal] = useState<boolean>(false)

  const onChangePeriod = (date: string) => {
    setCurrentDate(moment(date).format('YYYY-MM-DD'))
    setStartDate(date)
    setEndDate(moment(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss'))
  }

  const handleChangePeriod = (startDate: string, endDate: string) => {
    setCurrentDate(moment(startDate).format('YYYY-MM-DD'))
    setStartDate(startDate)
    setEndDate(endDate)
  }

  const viewShedule = (status: boolean) => {
    setViewSheduleStatus(status)
  }

  return (
    <ScheduleContext.Provider
      value={{
        therapistDescription,
        setTherapistDescription,
        isOpenInModal,
        setIsOpenInModal,
        userId,
        setUserId,
        contentSchedule,
        setContentSchedule,
        viewScheduleStatus,
        setViewSheduleStatus,
        currentDate,
        setCurrentDate,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        onChangePeriod,
        handleChangePeriod,
        viewShedule
      }}
    >
      {children}
    </ScheduleContext.Provider>
  )
}

export const useScheduleContext = () => {
  const context = useContext(ScheduleContext)

  return context
}
